import constantCreator from 'utils/constantCreator';
import api from 'utils/api';

const define = constantCreator('sms');
const SEND_SMS = define('SEND_SMS', true);

const initialState = {
  loading: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case SEND_SMS.PENDING:
      return { ...state, loading: true };
    case SEND_SMS.REJECTED:
    case SEND_SMS.RESOLVED:
      return { ...state, loading: false };
    default: return state;
  }
};

export const actions = {
  sendSMS: ({ mobile, text }) => ({
    type: SEND_SMS,
    promise: api.post('/sms', { mobile, text }),
    success: 'SMS Sent',
    error: 'Fail to Sent SMS'
  }),
};



// WEBPACK FOOTER //
// ./src/ducks/sms.js